// extracted by mini-css-extract-plugin
module.exports = {"head":"LatestRelease_head__2Npf2","active":"LatestRelease_active__13ZNc"};